import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import MainToggle from '@wix/da-ds/pkg/formControls/dsPresets/MainToggle';
import ButtonFieldLayout from '../../../../layouts/common/ButtonFieldLayout';
import { OriginalDeviationFieldName } from '../../types';

import s from './OpenForOrdersField.scss';

const OpenForOrdersField: React.FC<{}> = () => {
  const { t } = useTranslation();
  const id = useId();
  const { control } = useFormContext();
  const { field } = useController({
    name: OriginalDeviationFieldName.OPEN_FOR_ORDERS,
    control,
  });

  return (
    <ButtonFieldLayout
      label={t('originalDeviationPopup.form.openForOrders.label')}
      labelClassName={s['label']}
      labelProps={{ id: `${id}-label`, htmlFor: id }}
      subLabel={t('originalDeviationPopup.form.openForOrders.subLabel')}
      subLabelClassName={s['sub-label']}
    >
      <div className={s['toggle-wrap']}>
        <MainToggle
          id={id}
          variant="main"
          size="large"
          aria-labelledby={`${id}-label`}
          value={field.value}
          onChange={field.onChange}
        />
      </div>
    </ButtonFieldLayout>
  );
};
OpenForOrdersField.displayName = 'OpenForOrdersField';

export default OpenForOrdersField;
